import cn from 'classnames'
import React from 'react'

import {theme} from '@/theme/theme'

import {Text, TextFontWeight, TextVariant} from './Text'

type NumberBadgeProps = {
  number: number
  backgroundColor?: string
  textColor?: string
  textVariant?: TextVariant
  hasShadow?: boolean
  maxNumber?: number
  showZero?: boolean
  minHeight?: string
}

export const NumberBadge: React.FC<React.PropsWithChildren<NumberBadgeProps>> = ({
  number,
  backgroundColor = theme.palette.info.main,
  textColor = theme.palette.text.white,
  textVariant = TextVariant.caption,
  hasShadow = false,
  maxNumber = 9,
  showZero = false,
  minHeight = '18px',
}) => {
  return (
    <>
      {(number > 0 || (showZero && number === 0)) && (
        <div className={cn('badge', hasShadow && 'shadow')}>
          <Text
            variant={textVariant}
            color={textColor}
            fontWeight={TextFontWeight.bold}
            className="text-block"
          >
            {number > maxNumber ? `${maxNumber}+` : number}
          </Text>
        </div>
      )}

      <style jsx>{`
        .badge {
          color: ${theme.palette.text.white};
          font-weight: ${theme.fontWeight.bold};
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 16px;
          min-height: ${minHeight};
          padding: 0 ${theme.spacing[1]};
          background-color: ${backgroundColor};
          border-radius: 4px;
        }
        .shadow {
          box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.15);
        }
      `}</style>
    </>
  )
}
